import React, { useEffect, useContext } from 'react';

import { useCampusControlModes } from '../../context/CampusContextProvider';
import { CONTROL_MODE } from '../../config/control';
import { ACTIVITY } from '../../config/activity';

import processRealtimeData, { getHvacMode } from '../../utilities/ProcessRealtimeZoneHelper';
import { setThermalZoneStatus } from '../../utilities/ProcessRealtimeZoneHelper';

import { TempSettingsLockup } from '../TempSettingsLockup/TempSettingsLockup';
import { DataCardSmall } from '../DataCard/DataCardSmall';

import './ZoneCard.scss';

const ZoneCard = ({ zoneRealtimeData, selectZone, setZoneHealth }) => {
  const formattedZoneRealtime = processRealtimeData(zoneRealtimeData);
  const zoneStatus = setThermalZoneStatus(zoneRealtimeData);
  const campusControlModes = useCampusControlModes();

  const isOffline = zoneRealtimeData.offline;
  const isManaged = !zoneRealtimeData.unmanaged;

  useEffect(() => {
    setZoneHealth(formattedZoneRealtime.zoneStatusCSS);
  }, [zoneRealtimeData]);

  // console.log('---');
  // console.log('formattedZoneRealtime', formattedZoneRealtime);

  const { currentTemperature, temperatureLowerBound, temperatureUpperBound, temperatureSetting } =
    formattedZoneRealtime;
  const hvacMode = getHvacMode(zoneRealtimeData);

  // console.log('currentTemperature', currentTemperature);
  // console.log('temperatureLowerBound', temperatureLowerBound);
  // console.log('temperatureUpperBound', temperatureUpperBound);
  // console.log('temperatureSetting', temperatureSetting);
  // console.log('hvacMode', hvacMode);
  // console.log('zoneStatus', zoneStatus);
  // console.log('campusControlModes', campusControlModes);

  const renderControlModes = () => {
    if (isOffline) {
      return <DataCardSmall label="Offline" icon={ACTIVITY.OFFLINE.icon} />;
    }
    if (!isManaged) {
      return <DataCardSmall label="Unmanaged" icon={ACTIVITY.UNMANAGED.icon} />;
    }

    const zoneModes = [];

    if (zoneRealtimeData?.inLocalOverride && !zoneRealtimeData?.inOverride) {
      zoneModes.push({
        mode: 'LOCAL_OVERRIDE',
        isActive: true,
        customLabel: 'Local Override',
      });
    } else if (zoneRealtimeData?.inOverride) {
      zoneModes.push({
        mode: 'REMOTE_OVERRIDE',
        isActive: true,
        customLabel: 'Remote Override',
      });
    }

    if (zoneRealtimeData?.inEvent && zoneRealtimeData?.eventName) {
      zoneModes.push({
        mode: 'EVENT',
        isActive: true,
        customLabel: `Event: ${zoneRealtimeData.eventName}`,
      });
    }

    const combinedModes = [...zoneModes, ...(campusControlModes || [])];

    if (combinedModes.length === 0) {
      return <DataCardSmall label="No Active Control Modes" icon={ACTIVITY.DEFAULT.icon} />;
    }

    const activeCombinedModes = combinedModes.filter((mode) => {
      const targetMode = CONTROL_MODE[mode.mode.toUpperCase()];
      return targetMode && mode.isActive !== false;
    });

    if (activeCombinedModes.length === 0 && zoneRealtimeData?.unmanaged === false) {
      return (
        <DataCardSmall label={CONTROL_MODE.STANDARD.label} icon={CONTROL_MODE.STANDARD.icon} />
      );
    }

    return activeCombinedModes.map((controlMode, index) => {
      const targetMode = CONTROL_MODE[controlMode.mode.toUpperCase()];
      if (!targetMode || controlMode.isActive === false) return null;
      if (index > 0) return null; // only show the first for now
      return (
        <DataCardSmall
          key={`mode-${index}`}
          label={targetMode.label}
          icon={targetMode.icon}
          customLabel={controlMode?.customLabel || null}
        />
      );
    });
  };

  return (
    <>
      <div className="zone-card" onClick={selectZone}>
        <div className="location " onClick={selectZone}>
          <div className={'zone-health-indicator ' + formattedZoneRealtime.zoneStatusCSS}></div>
          {zoneRealtimeData && zoneRealtimeData.longThermalZoneDisplayName}
        </div>

        {/* <td className="status">
          <ThermalZoneStatusPill status={zoneStatus} />
        </td> */}

        <div className="temp-range">
          <TempSettingsLockup
            status={zoneStatus}
            temperature={currentTemperature}
            tempBounds={{ min: temperatureLowerBound, max: temperatureUpperBound }}
            hvacMode={hvacMode}
          />
        </div>

        <div className="activity">{formattedZoneRealtime.activityState}</div>
        <div className="keypad">{formattedZoneRealtime.keypadLock}</div>
        <div className="control">{renderControlModes()}</div>
        <div className="schedule">{formattedZoneRealtime.scheduleOrOverride}</div>

        {/* <div className="managed">{formattedZoneRealtime.controlState}</div> */}
      </div>
    </>
  );
};

export default ZoneCard;
